// src/app/security/UserDataInitializerProvider.ts
import { provideAppInitializer, inject, EnvironmentProviders } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

export const UserDataInitializerProvider: EnvironmentProviders = provideAppInitializer(() => {
  const router = inject(Router);
  const authService = inject(AuthService);
  // must return Promise<void> or void
  return initializeUser(router, authService);
});

// Return a Promise<void>, not a function
export function initializeUser(
  router: Router,
  authService: AuthService
): Promise<void> {
  return new Promise((resolve) => {
    authService.isSignedIn().then((signedIn) => {
      if (signedIn) {
        resolve();
      } else {
        authService.getUserDetails().then(() => resolve());
      }
    });
  });
}
